import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Download, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const WhatsAppQR = () => {
  const whatsappNumber = '491706684547';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  const message = 'Hi Aryan, I would like to discuss a project with you.';
  const whatsappLinkWithMessage = `${whatsappLink}?text=${encodeURIComponent(message)}`;

  const downloadQR = () => {
    const svg = document.getElementById('whatsapp-qr-code');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    canvas.width = 512;
    canvas.height = 512;

    img.onload = () => {
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, 512, 512);
      
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = 'aryan-shivhare-whatsapp-qr.png';
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <Card className="bg-gradient-to-br from-zinc-900 to-black border-gold-500/20 hover:border-gold-500/40 transition-all duration-300">
      <CardHeader className="text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-gold-500/10 flex items-center justify-center">
            <MessageCircle className="w-8 h-8 text-gold-500" />
          </div>
        </div>
        <CardTitle className="text-2xl font-display text-white">
          Quick Connect via WhatsApp
        </CardTitle>
        <CardDescription className="text-gray-400">
          Scan this QR code to start a conversation instantly
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-6">
        {/* QR Code */}
        <div className="p-6 bg-white rounded-2xl shadow-2xl">
          <QRCodeSVG
            id="whatsapp-qr-code"
            value={whatsappLinkWithMessage}
            size={200}
            level="H"
            includeMargin={true}
            imageSettings={{
              src: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
              height: 40,
              width: 40,
              excavate: true,
            }}
          />
        </div>

        {/* Info */}
        <div className="text-center">
          <p className="text-sm text-gray-400 mb-2">
            Open your camera app and point it at the QR code
          </p>
          <p className="text-xs text-gray-500">
            +49 170 6684547
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 w-full">
          <Button
            onClick={() => window.open(whatsappLinkWithMessage, '_blank')}
            className="flex-1 bg-[#25D366] hover:bg-[#20BD5A] text-white"
          >
            <MessageCircle className="w-4 h-4 mr-2" />
            Open WhatsApp
          </Button>
          <Button
            onClick={downloadQR}
            variant="outline"
            className="border-gold-500/30 text-gold-500 hover:bg-gold-500/10 hover:border-gold-500"
          >
            <Download className="w-4 h-4 mr-2" />
            Download QR
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default WhatsAppQR;
